module.exports = __webpack_public_path__ + "static/media/kv-all-roulette.f5b2483d.png";